import type { FunctionComponent } from "react"

import { Heading } from "@jobteaser/spark/components/Heading"

import { useCompanyEventsFetch } from "@/modules/companies/client/hooks/useCompanyEventsFetch"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./EventsTitle.module.css"

export const EventsTitle: FunctionComponent = () => {
  const { dataCompanyEvents } = useCompanyEventsFetch()
  const { t } = useTranslation(["companies_client"])
  const nbCompanyEvents = dataCompanyEvents?.events.length || 0

  return (
    <Heading variant="title2" weight="bold" as="h2" className={styles.main} data-testid="company_news_feed_event_title">
      {t("companies_client.newsFeed.events.title", { count: nbCompanyEvents })} ({nbCompanyEvents})
    </Heading>
  )
}
